<template><div><h1 id="ad-hoc-selektion-aufbereiten" tabindex="-1"><a class="header-anchor" href="#ad-hoc-selektion-aufbereiten"><span>Ad-Hoc Selektion aufbereiten</span></a></h1>
<p>Ad-Hoc Selektion, aufbereiten — Erstellung Dokumente, E-Mails und Datenexport aus Ad-Hoc-Selektion</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Job werden, je nach gewählter Option, Dokumente und Listen erstellt oder Daten exportiert. Für die Versände/Exporte können Erignisse angelegt werden.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen → Ad-Hoc Selektion → Button: aufbereiten...</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Outputoptionen (Radiobuttons)</dt>
<dd>
<table>
<thead>
<tr>
<th>Option</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Exportdatei</td>
<td>Erstellt eine Exportdatei, basierend auf einem Exportformat.</td>
</tr>
<tr>
<td>Brief (Document-Output)</td>
<td>Erstellt Dokumente, basierend auf einem Dokumentensatz</td>
</tr>
</tbody>
</table>
</dd>
<dt>Ausgabeformat (nur Option Exportdatei)</dt>
<dd>Lookup auf <RouteLink to="/referenz/refs/ft.refdata.exportformat.html" title="Exportformate">Exportformate</RouteLink></dd>
<dt>Anrede (für beide Optionen)</dt>
<dd>Lookup auf <RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Einzelanreden</RouteLink></dd>
<dt>Anredeset (für beide Optionen)</dt>
<dd>Lookup auf <RouteLink to="/referenz/refs/ft.refdata.tblanredesets.html" title="Anredesets">Anredesets</RouteLink></dd>
<dt>Ereignis (für beide Optionen)</dt>
<dd>Produziert beim Aufbereiten ein <RouteLink to="/referenz/refs/ft.refdata.ereignisse.html" title="Personenereignisse">Personenereignis</RouteLink> (Lookup auf <RouteLink to="/referenz/refs/ft.refdata.ereigkopf.html" title="Ereignisse">Ereigniskopf</RouteLink>). Mit den Personenereignissen werden auch Referenznummern produziert.</dd>
<dt>Ereignisposition (für beide Optionen)</dt>
<dd>Auswahl der <RouteLink to="/referenz/refs/ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</RouteLink></dd>
<dt>Status (für beide Optionen)</dt>
<dd>Lookup auf <RouteLink to="/referenz/refs/ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignisstatus</RouteLink>, mit dem das Personenereignis erfasst wird.</dd>
<dt>Kanal (für beide Optionen)</dt>
<dd>Lookup auf den <RouteLink to="/referenz/refs/ft.refdata.tblkommkanal.html" title="Kommunikationskanäle">Kommunikationskanal</RouteLink>.</dd>
<dt>Dokumentencode (nur Option Brief)</dt>
<dd>Auswahl eines Dokumentencodes (Attribut für die Dokumenterstellung)</dd>
<dt>Document Output/Prozess (ohne Label, nur Option Brief)</dt>
<dd>&quot;Dokumente/E-Mails erstellen&quot;: Erstellt Dokumente (ohne drucken)<br>&quot;Dokumente/E-Mails drucken/versenden&quot;: Erstellt und druckt Dokumente (direkte Ausgabe auf den im <RouteLink to="/referenz/refs/ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</RouteLink> definierten Drucker. Erstellt und versendet E-Mails.<br>&quot;Dokumente/E-Mails drucken/versenden&quot; soll, wie bei den Verdankungen, auch nach &quot;Dokumente/E-Mails erstellen&quot; ausgeführt werden können. So kann man nach dem erstellen die E-Mails konrollieren und nachträglich noch versenden.</dd>
<dt>Document Output/Dokumentensatz (nur Option Brief)</dt>
<dd>Lookup auf <RouteLink to="/referenz/refs/ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</RouteLink></dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Siehe Beschreibung oben.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ereignisse.html" title="Personenereignisse">Personenereignis</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.exportformat.html" title="Exportformate">Exportformate</RouteLink></p>
</div></template>


